import {
  AnalyticsEvent,
  AnalyticsEvents,
  Attribute,
  ConstructorAnalyticsEvent,
  ConstructorAnalyticsEventParameters,
  EventInfo,
} from '@o3r/analytics';
import {
  Category,
} from '@refx/analytics-core';
import {
  ClickOnCallCenterNumberEvent,
} from '@refx/servicing-common';

/**
 * @inheritDoc
 */
export class ClickOnCallCenterNumber implements ClickOnCallCenterNumberEvent {
  /* @inheritdoc */
  public eventInfo = {
    key: 'ClickOnCallCenterNumber' as const,
    eventName: 'Click on the call center number' as const
  };
}

/**
 * Interface to define the inputs that RecoveryError needs to be created
 */
export interface RecoveryErrorConstructorAnalyticsEventParameters extends ConstructorAnalyticsEventParameters {
  /**
   * error name
   */
  errorName: string;
}

/**
 * Event raised when the recovery page is displayed
 */
export class RecoveryError implements AnalyticsEvent {
  /** @inheritdoc */
  public eventInfo: EventInfo = {
    eventName: 'Error',
    key: 'GlobalError',
    pageId: 'GERR',
    componentId: 'refx-servicing-recovery'
  };

  /** @inheritdoc */
  public category: Category = {
    primaryCategory: 'Error'
  };

  /** @inheritdoc */
  public attributes: Attribute[] = [];

  constructor(parameters: RecoveryErrorConstructorAnalyticsEventParameters) {
    this.attributes.push({
      key: 'errorName',
      value: parameters.errorName
    });
  }
}

/**
 * Interface for the analytics of the recovery page
 */
export interface RecoveryComponentAnalytics extends AnalyticsEvents {
  clickOnCallCenterNumber: ConstructorAnalyticsEvent<ClickOnCallCenterNumber>;
  recoveryError: ConstructorAnalyticsEvent<RecoveryError>;
}

/**
 * Definition of the analytics of the recovery page
 */
export const analyticsEvents: RecoveryComponentAnalytics = {
  clickOnCallCenterNumber: ClickOnCallCenterNumber,
  recoveryError: RecoveryError
};
